import { createTheme } from '@mui/material/styles';

// Colores de marca TVS Latin America
const brandColors = {
  primary: '#004a8F',    // Azul corporativo
  secondary: '#E70033',  // Rojo de marca
  white: '#FFFFFF',      // Blanco
  lightGray: '#f5f5f5',  // Gris claro para fondos
  darkGray: '#333333',   // Gris oscuro para texto
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brandColors.primary,
      light: '#3373b3',
      dark: '#003366',
      contrastText: brandColors.white,
    },
    secondary: {
      main: brandColors.secondary,
      light: '#ff4d6a',
      dark: '#b3001a',
      contrastText: brandColors.white,
    },
    background: {
      default: brandColors.lightGray,
      paper: brandColors.white,
    },
    text: {
      primary: brandColors.darkGray,
      secondary: '#666666',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
      contrastText: brandColors.white,
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
      contrastText: brandColors.white,
    },
    error: {
      main: '#d32f2f',
      light: '#f44336',
      dark: '#b71c1c',
      contrastText: brandColors.white,
    },
    info: {
      main: '#2196f3',
      light: '#64b5f6',
      dark: '#1976d2',
      contrastText: brandColors.white,
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      color: brandColors.primary,
    },
    h6: {
      fontWeight: 600,
      color: brandColors.primary,
    },
    subtitle1: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
        contained: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: '1px solid #e0e0e0',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 500,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: brandColors.primary,
          '& .MuiTableCell-head': {
            color: brandColors.white,
            fontWeight: 600,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #e0e0e0',
        },
      },
    },
  },
});

export default theme;
